import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IUpdateTeplar } from '../../models/forms/IAddUpdateTeplar';
import { IDetailProps } from '../../models/forms/IForm';

const TeplarPrintDetails = (props: IDetailProps) => {
  const { teplarPrintStore } = useStore();
  const { teplarDetails, GetDetailsTeplarByIdService } = teplarPrintStore;
  const teplar: IUpdateTeplar = teplarDetails;

  useEffect(() => {
    if (props.selectedRowId > 0) {
      GetDetailsTeplarByIdService(
        Number(getTenantIdFromLocalStorage()),
        props.selectedRowId
      );
    }
  }, [props.selectedRowId]);

  return (
    <>
      <div className="px-4 py-3">
        <div className="row g-2">
          <div className="col-12">
            <p className="title_sidebar ">
              <FormattedMessage id={'format'} />{' '}
            </p>
            <h3 className="mb-0">{teplar.Format}</h3>
          </div>
        </div>

        <div className="row  mt-2 card bg-light py-2">
          <div className="col-12">
            <p className="title_sidebar">
              <FormattedMessage id={'items'} />{' '}
            </p>
            <ul className="templar_items">
              {teplar.Items.map((item) => {
                return <li key={item}>{item}</li>;
              })}
            </ul>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-6">
            <div className="d-flex align-items-center gap-3">
              <p className="title_sidebar">
                <FormattedMessage id={'layout'} />:
              </p>
              <h3 className="mb-0">{teplar.Layout}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center gap-3">
              <p className="title_sidebar">
                <FormattedMessage id={'width'} />:
              </p>
              <h3 className="mb-0">{teplar.Width}</h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(TeplarPrintDetails);
